import { render, staticRenderFns } from "./TotalCategoriesGraph.vue?vue&type=template&id=2d316458&"
import script from "./TotalCategoriesGraph.vue?vue&type=script&lang=js&"
export * from "./TotalCategoriesGraph.vue?vue&type=script&lang=js&"
import style0 from "./TotalCategoriesGraph.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
